import { Component } from '@angular/core';

@Component({
  selector: 'app-seo-landing',
  standalone: true,
  templateUrl: './seo-landing.component.html',
})
export class SeoLandingComponent {}

